<template>
    <v-row component="ProjectHeader">
        <v-col cols="4" class="blank">
            <btn
                class="face"
                :text="isFaceSelected ? 'VOICE' : 'FACE'"
                radius="mediumBottom"
                :icon="isFaceSelected ? 'account_circle' : 'grid_view'"
                :color="isSelected('directorscut')"
                @click="toggleDirectorsCut"
            />
        </v-col>
        <v-col cols="8" class="header">
            <div class="name">
                <btn
                    :size="'iconSmall'"
                    :icon="'arrow_back'"
                    :class="{ hidden: isFaceSelected }"
                    @click="$router.push(`/client/projects/${project.klient.id}`)"
                />
                <div class="holder">
                    <div class="client">{{ project.klient.obchodne_meno }}</div>
                    <div class="project">{{ project.nazov }}</div>
                </div>
                <span class="chip" :class="getProjectStatusCSS(project.status)">{{ project.status }}</span>
            </div>
            <div class="tabs">
                <nav-button
                    :text="'SHORTLIST'"
                    radius="mediumBottom"
                    :icon="'view_list'"
                    :color="isSelected('shortlist')"
                    :to="{ name: 'project-shortlist', params: { project_id: project.id } }"
                />
                <nav-button
                    :disabled="!projectIsOrderAble"
                    :text="'ORDER'"
                    radius="mediumBottom"
                    :icon="'shopping_cart'"
                    :color="isSelected('order')"
                    :to="{ name: 'project-order', params: { project_id: project.id } }"
                />
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'ProjectHeader',

    props: {
        project: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {};
    },

    methods: {
        isSelected(who) {
            if (who === 'directorscut') {
                return this.$route.query.dc === 'true' ? '' : 'ghostLight';
            }

            return this.$route.name.search(who) > 0 ? '' : 'ghostLight';
        },

        getProjectStatusCSS(state) {
            switch (state) {
                case 'CLOSED':
                    return 'closed';
                case 'IN PROGRESS':
                    return 'progress';
                case 'SENT':
                    return 'sent';
                case 'APPROVED':
                    return 'approved';
                default:
                    return '';
            }
        },

        toggleDirectorsCut() {
            const query = { ...this.$route.query };
            if (query.dc === 'true') {
                delete query.dc;
            } else {
                query.dc = 'true';
            }
            this.$router.push({ query });
        },
    },

    computed: {
        ...mapGetters(['projectIsOrderAble']),

        isFaceSelected() {
            return this.$route.query.dc === 'true';
        },
    },

    components: {},
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectHeader'] {
    position: relative;
    z-index: 2;

    .blank {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;

        .face {
            width: 85px;
        }
    }

    .header {
        display: flex;
        padding-bottom: 3px;
        padding-left: 8px;

        .hidden {
            opacity: 0.1;
        }
    }

    .name {
        .flex-row;
        align-items: center;
        justify-content: space-between;
        width: 50%;
        padding: 6px 24px 2px 0px;
        line-height: 1.2;

        .holder {
            .flex-column;
            flex: 1;
            margin: 0 10px;
            white-space: nowrap;
            overflow: hidden;

            .client {
                font-size: 12px;
                display: block;
                font-weight: normal;
            }

            .project {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                font-weight: 700;
                font-size: 14px;
            }
        }
    }

    .chip {
        font-size: 9px;
        font-weight: normal;
        padding: 2px 5px;
        border-radius: 10px;
        margin-left: 7px;
        border: 1px solid transparent;

        &.closed {
            color: rgba(0, 0, 0, 0.5);
            border-color: rgba(0, 0, 0, 0.3);
        }

        &.progress {
            color: white;
            background: @color_green !important;
        }

        &.sent {
            color: white;
            background: @color_orange !important;
        }

        &.approved {
            color: white;
            background: @color_blue !important;
        }
    }

    .tabs {
        width: 50%;
        position: relative;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        padding-left: 8px;

        [component='NavButton'] {
            padding: 0 12px 0 10px;
            border-top-width: 0;
            margin-right: 1px;
        }

        .line {
            width: calc(100% - 16px);
            height: 1px;
            background: @dark_dk;
            position: absolute;
            bottom: 8px;
            right: 8px;

            @media @smallheight {
                display: none;
            }
        }
    }
}
</style>
